"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const philosophies = [{
  title: "Industrial Aggregates",
  description: "Safety-First handling of stone and raw materials with specialized offloading equipment for industrial job sites.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/texture_concrete_raw.png"
}, {
  title: "Lumber Logistics",
  description: "High-precision last-mile delivery for lumber yards and building suppliers across the Dallas/Ft Worth metro area.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/texture_wood_grain_dark.png"
}, {
  title: "Regional Hauling",
  description: "Heavy-duty semi-truck fleet servicing the Southeast region with industrial-grade reliability and mass momentum.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1634045/img/texture_architectural_glass.png"
}];
export default function OurCorePhilosophy() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="123977" id="built-for-bulk-heavy-materials" className="dark bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-sm font-mono tracking-widest text-primary uppercase mb-4">
            TransitLink Operations
          </h2>
          <h3 className="text-4xl md:text-5xl lg:text-6xl font-default font-extrabold tracking-tighter text-foreground">
            Built for Bulk & Heavy Materials
          </h3>
          <div className="h-1 w-24 bg-primary mt-8"></div>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 transition-all duration-1000 delay-200 ease-out ${isGridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {philosophies.map((item, i) => <div key={i} data-index={i} className="group relative aspect-[4/5] overflow-hidden rounded-sm bg-card cursor-pointer">
              {}
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 ease-in-out group-hover:scale-105" style={{
            backgroundImage: `url(${item.image})`
          }} />
              
              {}
              <div className="absolute inset-0 bg-background/80 transition-colors duration-500 ease-in-out group-hover:bg-background/40" />

              {}
              <div className="absolute inset-0 p-8 md:p-10 flex flex-col justify-end z-10">
                <div className="transform transition-transform duration-500 ease-in-out group-hover:-translate-y-4">
                  <h4 className="text-3xl md:text-4xl font-default font-bold text-foreground mb-4">
                    {item.title}
                  </h4>
                  
                  {}
                  <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-in-out group-hover:grid-rows-[1fr]">
                    <p className="overflow-hidden text-foreground/90 text-lg leading-relaxed font-mono">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
              
              {}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-primary transition-all duration-500 ease-in-out group-hover:w-full z-20" />
            </div>)}
        </div>
      </div>
    </section>;
}